/**
 * Sender MedicalSpecialityCode → XML KvalifikatorDefinition.
 *
 * Texts are the official MedCom definitions (XREF01 / XREF15
 * MedicalSpecialityCodeType). Do not invent labels for unknown codes:
 * the raw code is shown so a new qualifier is still visible.
 */

const MEDICAL_SPECIALITY_LABEL: Readonly<Record<string, string>> = {
  ikkeklassificeret: 'Ikke klassificeret',
  blandet: 'Blandet medicin (Afsenders sygehusspeciale)',
  intern_medicin_sygehus: 'Intern medicin (Afsenders sygehusspeciale)',
  geriatri: 'Geriatri (Afsenders sygehusspeciale)',
  hepatologi: 'Hepatologi (Afsenders sygehusspeciale)',
  haematologi: 'Hæmatologi (Afsenders sygehusspeciale)',
  infektionsmedicin: 'Infektionsmedicin (Afsenders sygehusspeciale)',
  kardiologi: 'Kardiologi (Afsenders sygehusspeciale)',
  med_allergologi: 'Med. allergologi (Afsenders sygehusspeciale)',
  med_endokrinologi: 'Med. endokrinologi (Afsenders sygehusspeciale)',
  med_gastroenterologi: 'Med. gastroenterologi (Afsenders sygehusspeciale)',
  med_lungesygdomme: 'Med. lungesygdomme (Afsenders sygehusspeciale)',
  nefrologi: 'Nefrologi (Afsenders sygehusspeciale)',
  reumatologi: 'Reumatologi (Afsenders sygehusspeciale)',
  palliativ: 'Palliativ medicin (Afsenders sygehusspeciale)',
  akut: 'Akut medicin (Afsenders sygehusspeciale)',
  dermato_venerologi_sygehus: 'Dermato-venerologi (Afsenders sygehusspeciale)',
  neurologi: 'Neurologi (Afsenders sygehusspeciale)',
  onkologi: 'Onkologi (Afsenders sygehusspeciale)',
  kirurgi_sygehus: 'Kirurgi (Afsenders sygehusspeciale)',
  karkirurgi: 'Karkirurgi (Afsenders sygehusspeciale)',
  kir_gastroenterologi: 'Kir. gastroenterologi (Afsenders sygehusspeciale)',
  plastikkirurgi: 'Plastikkirurgi (Afsenders sygehusspeciale)',
  thoraxkirurgi: 'Thoraxkirurgi (Afsenders sygehusspeciale)',
  urologi: 'Urologi (Afsenders sygehusspeciale)',
  gynaekologi_obstetrik_sygehus: 'Gynækologi og obstetrik (Afsenders sygehusspeciale)',
  sexologi: 'Sexologi (Afsenders sygehusspeciale)',
  neurokirurgi: 'Neurokirurgi (Afsenders sygehusspeciale)',
  ortopaedisk_kirurgi_sygehus: 'Ortopædisk kirurgi (Afsenders sygehusspeciale)',
  oftalmologi: 'Oftalmologi (Afsenders sygehusspeciale)',
  oto_rhino_laryngologi: 'Oto-, rhino-, laryngologi (Afsenders sygehusspeciale)',
  hospitalsodontologi: 'Hospitalsodontologi (Afsenders sygehusspeciale)',
  psykiatri_sygehus: 'Psykiatri (Afsenders sygehusspeciale)',
  boerne_ungdomspsykiatri: 'Børne- og ungdomspsykiatri (Afsenders sygehusspeciale)',
  klin_biokemi: 'Klin. biokemi (Afsenders sygehusspeciale)',
  klin_fys_nuklearmedicin: 'Klin fys og nuklearmedicin (Afsenders sygehusspeciale)',
  klin_immunologi: 'Klin. immunologi (Afsenders sygehusspeciale)',
  klin_mikrobiologi: 'Klin. mikrobiologi (Afsenders sygehusspeciale)',
  klin_neurofysiologi: 'Klin. neurofysiologi (Afsenders sygehusspeciale)',
  patologisk_anatomi: 'Patologisk anatomi (Afsenders sygehusspeciale)',
  diagnostisk_radiologi: 'Diagnostisk radiologi (Afsenders sygehusspeciale)',
  klin_farmakologi: 'Klin. farmakologi (Afsenders sygehusspeciale)',
  klin_genetik: 'Klin. genetik (Afsenders sygehusspeciale)',
  paediatri_sygehus: 'Pædiatri (Afsenders sygehusspeciale)',
  anaestesiologi_sygehus: 'Anæstesiologi (Afsenders sygehusspeciale)',
  arbejdsmedicin: 'Arbejdsmedicin (Afsenders sygehusspeciale)',
  almen_medicin: 'Almen medicin (Afsenders sygehusspeciale)',
  samfundsmedicin: 'Samfundsmedicin (Afsenders sygehusspeciale)',
  retsmedicin: 'Retsmedicin (Afsenders sygehusspeciale)',
  fysioterapi_sygehus: 'Fysio- og ergoterapi (Afsenders sygehusspeciale)',
  anaestesiologi_praksis: 'Anæstesiologi (Afsenders praksisspeciale)',
  roentgen_kbh: 'Røntgen (København) (Afsenders praksisspeciale)',
  dermato_venerologi_praksis: 'Dermatologi-venerologi (Afsenders praksisspeciale)',
  roentgen: 'Røntgen. (Afsenders praksisspeciale)',
  reumatologi_fysiurgi: 'Reumatologi (Fysiurgi) (Afsenders praksisspeciale)',
  gynaekologi_obstetrik_praksis: 'Gynækologi/obstetrik (Afsenders praksisspeciale)',
  intern_medicin_praksis: 'Intern Medicin (Afsenders praksisspeciale)',
  kirurgi_praksis: 'Kirurgi (Afsenders praksisspeciale)',
  klinisk_kemi: 'Klinisk kemi. (Afsenders praksisspeciale)',
  neurokirurgi_praksis: 'Neurokirurgi (Afsenders praksisspeciale)',
  neuromedicin: 'Neuromedicin (Afsenders praksisspeciale)',
  oejenlaege: 'Øjenlæge (Afsenders praksisspeciale)',
  oere_naese_halslaege: 'Øre, Næse halslæge (Afsenders praksisspeciale)',
  ortopaedisk_kirurgi_praksis: 'Ortopædisk Kirurgi (Afsenders praksisspeciale)',
  patologi: 'Patologi (Afsenders praksisspeciale)',
  plastkirurgi: 'Plastkirurgi (Afsenders praksisspeciale)',
  psykiatri_praksis: 'Psykiatri (Afsenders praksisspeciale)',
  paediatri: 'Pædiatri (Afsenders praksisspeciale)',
  boernepsykiatri: 'Børnepsykiatri (Afsenders praksisspeciale)',
  tropemedicin: 'Tropemedicin (Afsenders praksisspeciale)',
  med_laboratorier_kpll: 'KPLL (Afsenders praksisspeciale)',
  med_laboratorier: 'Med. laboratorier (Afsenders praksisspeciale)',
  omegnslaboratorier: 'Omegnslaboratorier (Afsenders praksisspeciale)',
  med_laboratorier_ssi: 'SSI (Afsenders praksisspeciale)',
  tandplejere: 'Tandplejere (Afsenders praksisspeciale)',
  tandlaege: 'Tandlæge (Afsenders praksisspeciale)',
  fysioterapi: 'Fysioterapi (Afsenders praksisspeciale)',
  briller: 'Briller (Afsenders praksisspeciale)',
  kiropraktor: 'Kiropraktor (Afsenders praksisspeciale)',
  fodterapi: 'Fodterapi (Afsenders praksisspeciale)',
  fodbehandlking: 'Fodbehandling (Afsenders praksisspeciale)',
  ridefysioterapi: 'Ridefysioterapi (Afsenders praksisspeciale)',
  teddy: 'Teddy Øfeldt (Afsenders praksisspeciale)',
  fodterapi_radioaktiv: 'Fodterapi - følger radioaktiv bestråling (Afsenders praksisspeciale)',
  fodterapi_leddegigt: 'Fodterapi - svær leddegigt (Afsenders praksisspeciale)',
  fysioterapi_vederlagsfri: 'Vederlagsfri fysioterapi (Afsenders praksisspeciale)',
  psykolog: 'Psykolog (Afsenders praksisspeciale)',
  kiropraktor_64: 'Kiropraktik - ordning 64 (Afsenders praksisspeciale)',
  ridefysioterapi_vederlagsfri: 'Vederlagsfri ridefysioterapi (Afsenders praksisspeciale)',
  almenlaege_laegevagt: 'Almenlæge og lægevagt (Afsenders praksisspeciale)',
  vagtlaege: 'Almenlæge og lægevagt (Afsenders praksisspeciale)',
  almenlaege_vagtkoersel: 'Almen lægers vagtkørsel (Afsenders praksisspeciale)',
  almenlaege_vagtlaegehjaelp: 'Vagtlægehjælp, region hovedstaden (Afsenders praksisspeciale)',
  vagtlaegehjaelp_kbh: 'Vagtlægehjælp, region hovedstaden (Afsenders praksisspeciale)',
  vagtlaegehjaelp: 'Vagtlægehjælp (Afsenders praksisspeciale)',
};

export function medicalSpecialityLabel(code: string): string {
  return MEDICAL_SPECIALITY_LABEL[code] ?? code;
}
